import { Form } from "react-bootstrap";
import { ReactNode } from "react";
import { AnalyserConfigOptionValue, AnalyserConfigOption } from "../../../../../../../models/analysis/Config";
import AlgorithmOptionSelectionInput from "./inputs/AlgorithmOptionSelectionInput";
import AlgorithmOptionNumberInput from "./inputs/AlgorithmOptionNumberInput";
import AlgorithmOptionBooleanInput from "./inputs/AlgorithmOptionBooleanInput";
import AlgorithmOptionRegionInput from "./inputs/AlgorithmOptionRegionInput";

export interface BaseAlgorithmOptionInputProps {
    option: AnalyserConfigOption;
    onChanged: (update: AnalyserConfigOptionValue) => void;
}

export interface ImportWizardOptionProps extends BaseAlgorithmOptionInputProps {
    value: AnalyserConfigOptionValue;
    previewImgUrl: string | undefined;
    previewVidUrl: string | undefined;
}

export interface AlgorithmOptionInputProps extends BaseAlgorithmOptionInputProps {
    default?: AnalyserConfigOptionValue;
}

function AlgorithmOptionInput(props: ImportWizardOptionProps) {
    const defaultValue = props.value ?? props.option.default;
    const inputProps: AlgorithmOptionInputProps = {
        option: props.option,
        onChanged: props.onChanged,
        default: defaultValue,
    };

    let formInput: ReactNode;
    switch (props.option.type) {
        case "integer":
            formInput = <AlgorithmOptionNumberInput {...inputProps} step={1} />;
            break;
        case "percentage":
            formInput = <AlgorithmOptionNumberInput {...inputProps} step={10} />;
            break;
        case "selection":
            formInput = <AlgorithmOptionSelectionInput {...inputProps} />;
            break;
        case "boolean":
            formInput = <AlgorithmOptionBooleanInput {...inputProps} />;
            break;
        case "region":
            formInput = (
                <AlgorithmOptionRegionInput
                    {...inputProps}
                    previewVidUrl={props.previewVidUrl}
                    previewImgUrl={props.previewImgUrl}
                />
            );
    }

    return (
        <Form.Group as="section">
            <Form.Label className="fw-semibold">{props.option.displayName}</Form.Label>
            {formInput}
        </Form.Group>
    );
}

export default AlgorithmOptionInput;
